/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Failedsubscribe1Inputs */

const id_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal berlangganan notifikasi`)
};

const ms_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal melanggan pemberitahuan`)
};

const da_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke abonnere på notifikationer`)
};

const de_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement der Benachrichtigungen fehlgeschlagen`)
};

const en_us2_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to notifications`)
};

const es_es2_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al suscribirse a las notificaciones`)
};

const es_mx2_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al suscribirse a las notificaciones`)
};

const fil_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong mag-subscribe sa mga notipikasyon`)
};

const fr_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'abonnement aux notifications`)
};

const it_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile iscriversi alle notifiche`)
};

const hu_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen feliratkozás az értesítésekre`)
};

const nl_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonneren op meldingen mislukt`)
};

const no_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke abonnere på varsler`)
};

const pl_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się subskrybować powiadomień`)
};

const pt_br2_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to notifications`)
};

const pt_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao subscrever notificações`)
};

const ro_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonarea la notificări a eșuat`)
};

const fi_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitusten tilaus epäonnistui`)
};

const sv_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att prenumerera på notiser`)
};

const vi_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký nhận thông báo thất bại`)
};

const tr_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimlere abone olunamadı`)
};

const cs_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se přihlásit k oznámením`)
};

const bg_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно абониране за известия`)
};

const ru_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось подписаться на уведомления`)
};

const uk_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося підписатися на сповіщення`)
};

const ar_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل الاشتراك في الإشعارات`)
};

const hi_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाओं की सदस्यता लेने में विफल`)
};

const th_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับการแจ้งเตือนไม่สำเร็จ`)
};

const ja_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知の購読に失敗しました`)
};

const zh_cn2_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to notifications`)
};

const zh_hant1_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to notifications`)
};

const ko_notifications_simple_failedsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to subscribe to notifications`)
};

/**
* | output |
* | --- |
* | "Failed to subscribe to notifications" |
*
* @param {Notifications_Simple_Failedsubscribe1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_failedsubscribe1 = /** @type {((inputs?: Notifications_Simple_Failedsubscribe1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Failedsubscribe1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_failedsubscribe1(inputs)
	if (locale === "ms") return ms_notifications_simple_failedsubscribe1(inputs)
	if (locale === "da") return da_notifications_simple_failedsubscribe1(inputs)
	if (locale === "de") return de_notifications_simple_failedsubscribe1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_failedsubscribe1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_failedsubscribe1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_failedsubscribe1(inputs)
	if (locale === "fil") return fil_notifications_simple_failedsubscribe1(inputs)
	if (locale === "fr") return fr_notifications_simple_failedsubscribe1(inputs)
	if (locale === "it") return it_notifications_simple_failedsubscribe1(inputs)
	if (locale === "hu") return hu_notifications_simple_failedsubscribe1(inputs)
	if (locale === "nl") return nl_notifications_simple_failedsubscribe1(inputs)
	if (locale === "no") return no_notifications_simple_failedsubscribe1(inputs)
	if (locale === "pl") return pl_notifications_simple_failedsubscribe1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_failedsubscribe1(inputs)
	if (locale === "pt") return pt_notifications_simple_failedsubscribe1(inputs)
	if (locale === "ro") return ro_notifications_simple_failedsubscribe1(inputs)
	if (locale === "fi") return fi_notifications_simple_failedsubscribe1(inputs)
	if (locale === "sv") return sv_notifications_simple_failedsubscribe1(inputs)
	if (locale === "vi") return vi_notifications_simple_failedsubscribe1(inputs)
	if (locale === "tr") return tr_notifications_simple_failedsubscribe1(inputs)
	if (locale === "cs") return cs_notifications_simple_failedsubscribe1(inputs)
	if (locale === "bg") return bg_notifications_simple_failedsubscribe1(inputs)
	if (locale === "ru") return ru_notifications_simple_failedsubscribe1(inputs)
	if (locale === "uk") return uk_notifications_simple_failedsubscribe1(inputs)
	if (locale === "ar") return ar_notifications_simple_failedsubscribe1(inputs)
	if (locale === "hi") return hi_notifications_simple_failedsubscribe1(inputs)
	if (locale === "th") return th_notifications_simple_failedsubscribe1(inputs)
	if (locale === "ja") return ja_notifications_simple_failedsubscribe1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_failedsubscribe1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_failedsubscribe1(inputs)
	return ko_notifications_simple_failedsubscribe1(inputs)
});
export { notifications_simple_failedsubscribe1 as "notifications.simple.failedSubscribe" }